import { Modal } from 'baseui/modal';
import React from 'react';
import { FinalButton } from '../../Components/FinalButton';
import { Text } from '../../globalStyles';
import { useHistory } from 'react-router-dom';
import { InlineSVG } from '../../Components/Icons';
import { AppView } from '../../graphQL';

interface Props {
  userInfo?: {
    userId: number;
    email: string;
  };
  onClose: () => void;
  appView: AppView;
}

export function DuplicateEmailModal({ userInfo, appView, onClose }: Props) {
  const history = useHistory();

  if (!userInfo || appView !== AppView.Mcp) {
    return (
      <Modal isOpen unstable_ModalBackdropScroll onClose={onClose}>
        <div className="pa5">
          <InlineSVG icon="alert-circle" size={24} kind="danger" />
          <ReferrerDuplicateEmail />
        </div>
      </Modal>
    );
  }

  const onGoToProfile = () => {
    history.push(`/users/${userInfo.userId}`);
  };

  const modalLogic =
    appView === AppView.Mcp ? (
      <McpDuplicateEmail email={userInfo.email} onGoToProfile={onGoToProfile} onClose={onClose} />
    ) : (
      <ReferrerDuplicateEmail />
    );

  return (
    <Modal isOpen unstable_ModalBackdropScroll onClose={onClose}>
      <div className="pa5">
        <InlineSVG icon="alert-circle" size={24} kind="danger" />
        {modalLogic}
      </div>
    </Modal>
  );
}

const McpDuplicateEmail = ({
  email,
  onGoToProfile,
  onClose,
}: {
  email: string;
  onGoToProfile: () => void;
  onClose: () => void;
}) => {
  return (
    <div>
      <Text.h2>An account with that email already exists</Text.h2>
      <Text.body className="mt3">
        We cannot add this student to your referral list because the email {email} already has an
        account.
      </Text.body>
      <Text.body className="mt3">
        If you’d like to make a referral for this student, please do so through the “Add/Edit”
        function in the Care Types section of the student’s profile page.
      </Text.body>
      <div className="flex flex-column gap-3 mt4">
        <FinalButton kind="outline_black" onClick={onGoToProfile}>
          Go to student profile
        </FinalButton>
        <FinalButton kind="minimal_black" onClick={onClose}>
          Use different email address
        </FinalButton>
      </div>
    </div>
  );
};

const ReferrerDuplicateEmail = () => {
  const onClick = () => {
    <Text.externalLink href="mailto:hi@mantrahealth.com" target="_blank" rel="noopener noreferrer">
      hi@mantrahealth.com
    </Text.externalLink>;
  };
  return (
    <div>
      <Text.h2>Referral not complete: Existing Student Account</Text.h2>
      <Text.body className="mt3">
        Please Contact Mantra Care Navigation to determine eligibility for care activation.
      </Text.body>

      <div className="flex flex-column gap-3 mt4">
        <FinalButton kind="outline_black" onClick={onClick}>
          Email hi@mantrahealth.com
        </FinalButton>
      </div>
    </div>
  );
};
